import type { SVGProps } from 'react';
const SvgWifiOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wifi_off_svg__a)">
      <path
        fill="currentColor"
        d="M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7l2-2Zm-4 4a9.793 9.793 0 0 0-4.49-2.56l3.53 3.53.96-.97ZM2 3.05 5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24A9.684 9.684 0 0 0 5 13v.01L6.99 15a7.042 7.042 0 0 1 4.92-2.06L18.98 20l1.27-1.26L3.29 1.79 2 3.05ZM9 17l3 3 3-3a4.237 4.237 0 0 0-6 0Z"
      />
    </g>
    <defs>
      <clipPath id="wifi_off_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWifiOff;
